var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "generated-outfit-info-container",
        class: {
          fullView: _vm.showShopItems,
          "hide-initial-buttons": _vm.hideInitialButtons,
          "overflow-visible": _vm.isShareModalOpened
        },
        style: _vm.cssProps
      },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shareLoading,
                  expression: "shareLoading"
                }
              ],
              staticClass: "loading-overlay"
            },
            [_c("loader")],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swipe-up-container",
            class: { hasShare: _vm.instagramInstalled },
            on: { touchstart: _vm.dragstart, touchend: _vm.dragend }
          },
          [
            _c("div", { staticClass: "info-buttons" }, [
              _c(
                "div",
                { staticClass: "wtw-container full text-center" },
                [
                  _c("share-outfit", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.hideInitialButtons || _vm.showShopItems,
                        expression: "!hideInitialButtons || showShopItems"
                      }
                    ],
                    attrs: { outfit: _vm.outfitCurrent, classes: "trash" }
                  }),
                  _vm._v(" "),
                  !_vm.showShopItems
                    ? _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.hideInitialButtons,
                              expression: "!hideInitialButtons"
                            }
                          ],
                          staticClass: "button gray half-button",
                          on: { click: _vm.shopItems }
                        },
                        [
                          _vm._v(
                            "\n                        Shop Items\n                    "
                          )
                        ]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "button gray half-button back-button",
                          on: { click: _vm.shopItems }
                        },
                        [
                          _vm._v(
                            "\n                        Back\n                    "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c("purchase-outfit-button", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.hideInitialButtons || _vm.showShopItems,
                        expression: "!hideInitialButtons || showShopItems"
                      }
                    ],
                    attrs: {
                      classes: "button pink half-button",
                      outfit: _vm.outfitCurrent
                    }
                  })
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "blur-svg",
            attrs: {
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink"
            }
          },
          [
            _c("defs", [
              _c(
                "filter",
                { attrs: { id: "blur-filter" } },
                [_c("feGaussianBlur", { attrs: { stdDeviation: "20" } })],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "generated-outfit-items-container",
            class: { blur: _vm.showSwapProduct }
          },
          [
            _vm.outfitCurrent
              ? _c(
                  "div",
                  { staticClass: "wtw-container" },
                  [
                    _c(
                      "transition-group",
                      { attrs: { name: "generated-outfit" } },
                      _vm._l(_vm.outfitCurrent.products, function(product) {
                        return _c(
                          "div",
                          {
                            key: product.product_id,
                            staticClass: "generated-outfit-item"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "outfit-item-image",
                                style: {
                                  backgroundImage:
                                    "url(" + product.product_image_url + ")"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return function() {
                                      return _vm.handleItemImageClick(product)
                                    }.apply(null, arguments)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "icons-container" }, [
                                  _c(
                                    "span",
                                    { staticClass: "icon" },
                                    [
                                      _c("save-product", {
                                        attrs: {
                                          product: product,
                                          saveProductClassList:
                                            _vm.saveProductClassList,
                                          outfitId: _vm.outfitCurrent.outfit_id
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isGeneratedOutfit
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "icon",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.removeProductFromOutfit(
                                                product
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "trash",
                                            attrs: {
                                              src: _vm.imageUrl("trash.svg")
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isSavedOutfit
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "icon",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.$emit(
                                                "swap-product",
                                                product,
                                                _vm.outfitCurrent
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "swap",
                                            attrs: {
                                              src: _vm.imageUrl("swap.svg")
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "outfit-info" }, [
                              product.product_brand_title
                                ? _c("div", { staticClass: "item-brand" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(product.product_brand_title) +
                                        "\n                            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "item-name",
                                  class: {
                                    noBrand: !product.product_brand_title
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(product.product_title) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "item-price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("currency")(product.product_price)
                                  )
                                )
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53793338", { render: render, staticRenderFns: staticRenderFns })
  }
}